const HEALTH_CARE_CARD_NUMBER_PATTERN = /^\d{16}$/;

export function isValidHealthCareCardNumber(value) {
  return HEALTH_CARE_CARD_NUMBER_PATTERN.test(value);
}
